import { type SceneJsonDto, decodeSceneJsonDto } from '@seddi/scene';
import type { SceneDesc } from '@seddi/ui-three-viewer';

/**
 * Import scene data.
 * @param sceneDto Scene DTO.
 */
export const importScene = async (sceneDto: SceneJsonDto): Promise<SceneDesc> => {
  // Decode binary buffers.
  const scene = decodeSceneJsonDto(sceneDto) as SceneDesc;

  // Remove unnecesary entities.
  scene.children = scene.children.filter(e => {
    if (e.components.avatar || e.components.mesh) return false;
    return true;
  });

  return scene;
};
